import { Stack, Typography } from '@mui/material';
import * as React from 'react';
import { FsokPaper } from './UIComponents/FsokPaper/FsokPaper';

interface NySokContainerProps {
  heading: string;
}

export const NySokContainer = (
  props: React.PropsWithChildren<NySokContainerProps>
) => (
  <FsokPaper
    style={{
      padding: '32px',
      marginTop: '16px',
      marginBottom: '24px',
    }}
  >
    <Stack direction={'row'}>
      <Typography variant={'h5'} color={'primary'}>
        {props.heading}
      </Typography>
    </Stack>
    {props.children}
  </FsokPaper>
);
